import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Form } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Docmnt from '../../../../assets/images/google-docs.png';
import Rapdf from "../../../../assets/images/pdf.png";
import Arcv from "../../../../assets/images/archive.svg";
import Linktab from "../../../../assets/images/linktab.png";
import { Tab, Tabs, Button } from 'react-bootstrap';
import { toast } from 'react-toastify'; 
import pen from "../../../../assets/images/pen.png";
import { Link, useHistory } from 'react-router-dom';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import GalleryView from './Common/GalleryView.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const Acceptance = () => {

  const isMounted = useRef(false);
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [damageType, setDamageType] = useState([]);
  const [totalRows, setTotalRows] = useState({});
  const [totalRowsR, setTotalRowsR] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [activeTab, setActiveTab] = useState('Active');
  const [resetFilter, setResetFilter] = useState(false);
  const gridRef = useRef(null);
  const gridRefs = {
    Active: useRef(null),
    Archived: useRef(null),
  };
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(false);
    setGridData({ Active: {} });
    isMounted.current = true;
  }, []);


  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);


  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
    setFilterApplied(false);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
  }
  const handleDropdownItemClick = () => {

  }

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {
    if (gridRef?.current) {
      // if (gridData[activeTab]) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'I' }
      const source = {
        datatype: 'json',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'awbId', type: 'string' },
          // { name: 'shipment_number', type: 'string' },
          { name: 'connection', type: 'string' },
          { name: 'cutoff_datetime', type: 'string' },
          { name: 'pick_status', type: 'string' },
          { name: 'take_in', type: 'date' },
          { name: 'receipt', type: 'string' },
          { name: 'bonded', type: 'string' },
          { name: 'label_id', type: 'string' },
          { name: 'shipment_id', type: 'string' },
          { name: 'location', type: 'string' },
          { name: 'destination', type: 'string' },
          { name: 'expected_pieces', type: 'string' },
          { name: 'expected_weight', type: 'string' },
          { name: 'received_pieces', type: 'string' },
          { name: 'received_weight', type: 'string' },
          { name: 'shipper_name', type: 'string' },
          { name: 'shipper_city', type: 'string' },
          { name: 'address_lbl', type: 'string' },
          { name: 'dg', type: 'string' },
          { name: 'dg_lbl', type: 'string' },
          { name: 'security', type: 'string' },
          { name: 'damage', type: 'string' },
          { name: 'remarks', type: 'string' },
          { name: 'accepted_by', type: 'string' },
          { name: 'station', type: 'string' },
          { name: 'record_id', type: 'string' },
          { name: 'remarks', type: 'string' },
        ],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}shipment-export/acceptance?type=${tabType}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        // localdata: gridData[activeTab],
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


          // setTimeout(() => {
          //     const rows = window.$(gridRef.current).jqxGrid('getrows');

          //     console.log("rows", rows);
          //     (checkUlds).forEach(uldNumber => {
          //         console.log(checkUlds);
          //         rows.forEach((element, index) => {
          //             if (element.uld_number == uldNumber) {
          //                 window.$(gridRef.current).jqxGrid('selectrow', index);
          //             }
          //         });
          //     });
          // }, 4000);
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          setTotalRows({ totalUlds: data.activeCount });
          setTotalRowsR({ totalUlds: data.archiveCount });
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        // {
        //   text: 'Actions',
        //   cellsrenderer: function () {
        //     return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
        //   },
        //   width: '5%', filterable: false,
        // },
        // {
        //   text: 'Pick Status', filtertype: 'checkedlist', datafield: 'pick_status', width: '10%',
        //   cellclassname: (row, column, value, rowData, cellvalue) => {
        //     if (rowData.pick_status == 'Completed') {
        //       return "awb_green";
        //     } else if (rowData.pick_status == 'Completed') {
        //       return "awb_red";
        //     } else if (rowData.pick_status == 'In Progress') {
        //       return "awb_orange";
        //     } else if (rowData.pick_status == 'Open') {
        //       return "awb_blue";
        //     } else if (rowData.pick_status == 'Initiated') {
        //       return "awb_sky";
        //     } else {
        //       return;
        //     }
        //   },
        // },
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
          },
          width: '4%', filterable: false,
        },
        { text: 'Record ID', filtertype: 'input', datafield: 'record_id', width: '8%', cellclassname: '', },
        { text: 'Label ID', filtertype: 'input', datafield: 'label_id', width: '8%', cellclassname: '', },
        {
          text: 'Shipment ID', filtertype: 'input', datafield: 'shipment_id', width: '8%', cellclassname: '',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            // defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            if (cellValue) {
              // console.log('cellValue', cellValue);
              defaultHtml = '<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px">' + cellValue + '</div>';
            } else {
              defaultHtml = '<div class="set_fn shid"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
        { text: 'Take In', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'take_in', width: '5%', cellclassname: '', },
        { text: 'Remarks', filtertype: 'input', datafield: 'remarks', width: '8%', cellclassname: '', },
        {
          text: 'Receipt', filterable: false, width: '5%', cellclassname: '', dataField: 'receipt',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            // console.log('aa', cellValue);
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        
       
         { text: 'Shipper Name', filtertype: 'input', datafield: 'shipper_name', width: '6%', cellclassname: '', },
         { text: 'Shipper City', filtertype: 'input', datafield: 'shipper_city', width: '6%', cellclassname: '', },
           { text: 'Destination', filtertype: 'input', datafield: 'destination', width: '6%', cellclassname: '', },
           
        // { text: 'Location', filtertype: 'textbox', datafield: 'location', width: '8%', cellclassname: '', },
        {
          text: 'Location', filtertype: 'input', width: '8%', cellclassname: '', datafield: 'location',
          cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, data) {
            // defaultHtml = "<div style='text-align: center;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            if (cellValue) {
              // console.log('cellValue', cellValue);
              defaultHtml = '<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px">' + cellValue + '<span class="screen"><img src="' + pen + '" class="" /></span></div>';
            } else {
              defaultHtml = '<div class="set_fn screen"><span class=""><img src="' + pen + '" class="" /> Set</span></div>';
            }
            return (
              defaultHtml
            );
          },
        },
      
        
        
        { text: 'Bonded', filtertype: 'input', datafield: 'bonded', width: '4%', cellclassname: '', },
        { text: 'Expected pcs', filtertype: 'input', datafield: 'expected_pieces', width: '6%', cellclassname: '', },
        { text: 'Expected wgt', filtertype: 'input', datafield: 'expected_weight', width: '6%', cellclassname: '', },
        { text: 'Recieved pcs', filtertype: 'input', datafield: 'received_pieces', width: '6%', cellclassname: '', },
        { text: 'Recieve wgt', filtertype: 'input', datafield: 'received_weight', width: '6%', cellclassname: '', },
        { text: 'Damage ', filtertype: 'input', datafield: 'damage', width: '5%', cellclassname: '', },
        { text: 'Station', filtertype: 'input', datafield: 'station', width: '5%', cellclassname: '', },
       
        // { text: 'Address LBL ', filtertype: 'textbox', datafield: 'address_lbl', width: '6%', cellclassname: '', },
        // { text: 'DG  ', filtertype: 'textbox', datafield: 'dg', width: '4%', cellclassname: '', },
        // { text: 'DG LBL ', filtertype: 'textbox', datafield: 'dg_lbl', width: '5%', cellclassname: '', },
        // { text: 'Security ', filtertype: 'textbox', datafield: 'security', width: '5%', cellclassname: '', },
        // { text: 'Remarks ', filtertype: 'textbox', datafield: 'remarks', width: '5%', cellclassname: '', },
        // { text: 'Accepted By  ', filtertype: 'textbox', datafield: 'accepted_by', width: '5%', cellclassname: '', },
        
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        height: 1040,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 20,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
        // rendered: function () {
        //   const rows = window.$(gridRef.current).jqxGrid('getrows');
        //   (checkUlds).forEach(uldNumber => {
        //     rows.forEach((element, index) => {
        //       if (element.uld_number == uldNumber) {
        //         window.$(gridRef.current).jqxGrid('selectrow', index);
        //       }
        //     });
        //   });
        // }
      };
      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(gridRef.current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        console.log("🚀 ~ rowDiv:", rowDiv)
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);

        loadDetails(rowData.awbId, 'E');
        // window.location.href='/ForwarderShipments/CreateCargo'
        // setEditData(dataToSend);
        // setShowEdit(true);
      });
      window.$(gridRef.current).on('click', '.screen', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        setModalData({ location: rowData.location, shipmentId: rowData.shipment_id, awbId: rowData.awbId });
        setModalSec('L')
        setIsModal(true)
      });
      window.$(gridRef.current).on('click', '.shid', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        setModalData({ shipment_id: rowData.shipment_id, awbId: rowData.awbId });
        setModalSec('S')
        setIsModal(true)
      });
      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRef.current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row;
          const uldNumber = selectedRow.awbId;
          const selectedRowId = selectedRow.uid;
          if (!checkUlds.includes(uldNumber)) {
            checkUlds.push(uldNumber);
          }
          // console.log(checkUlds);
          // if (!gridSelect.some(row => row.awbId === uldNumber)) {
          //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
          // }
          setGridSelect(prevGridSelect => {
            if (!prevGridSelect.some(row => row.awbId === uldNumber)) {
              return [...prevGridSelect, selectedRow];
            }
            return prevGridSelect;
          });
        } else {
          if (event.args.rowindex.length > 0) {
            const allIds = window.$(gridRef.current).jqxGrid('getrows');
            setGridSelect(allIds);
          } else {
            setGridSelect([]);
          }
        }
      });
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.awbId;
          setGridSelect(prevSelection => prevSelection.filter(row => row.awbId !== unselectedRowId));
          // if(filterForCheck!=true){
          if (!checkUlds.includes(unselectedRowId)) {
            checkUlds.push(unselectedRowId);
          } else {
            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
          }
          // }
          // console.log(checkUlds);

        }
      });
      window.$(gridRef.current).off('cellclick');
      window.$(gridRef.current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (![0, 1, 4, 6, 10].includes(event.args.columnindex)) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          loadDetails(args.awbId);
          // setSelectedRowData(args)
        }
      });
      // }
    }
  }, [gridData]);

  // const loadDetails = async (uldNumber) => {
  //   try {
  //     const res = await withRFSToken.get(`shipment-export/get-cargo-details/${id}`, {})
  //       .then(function (res) {
  //         const innerData = res.data.response_data;
  //         setSelectedRowData(innerData);

  //         setTimeout(() => {
  //           window.$(gridRef.current).jqxGrid('refresh');
  //         }, 30);
  //       });
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // }
  const loadDetails = async (id, pos) => {
    let endPoint;
    if (pos == 'E') {
      endPoint = `shipment-export/get-cargo-details/${id}`
    } else {
      endPoint = `shipment-export/get-export-details/${id}`
    }
    try {
      const res = await withRFSToken.get(endPoint, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          if (pos === 'E') {
            localStorage.setItem('EditCargo', JSON.stringify(innerData));
            localStorage.setItem('ccbackUrl', JSON.stringify('/ForwarderShipments/Export'));
            history.push('/ForwarderShipments/CreateCargo');
          } else {
            setSelectedRowData(innerData);

            setTimeout(() => {
              window.$(gridRef.current).jqxGrid('refresh');
            }, 30);
          }

        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleCloseClick = () => {
    setSelectedRowData(null);
    setTimeout(() => {
      window.$(gridRef.current).jqxGrid('refresh');
    }, 30);
  };
  const [galleryOpen, setGalleryOpen] = useState(false);
  const showGalleryModal = () => {
    setGalleryOpen(true);
  };
  const closeGalleryModal = () => {
    setGalleryOpen(false);
  };
  // upload Section
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);

  // const imageModalUpload = (id) => {
  //     setSelectedRowId(id);
  //     setShowModalUpload(true)
  //     setFiles([])
  // }
  const imageModalUpload = (id) => {
    const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
    setFiles(selectedRowFiles);
    setSelectedRowId(id); // Store the ID of the selected row
    setShowModalUpload(true);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  // const handleFileChange = (e) => {
  //     const selectedFiles = Array.from(e.target.files);
  //     const filesWithBase64 = [];
  //     selectedFiles.forEach((file) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //             filesWithBase64.push({ file, base64: reader.result });
  //             if (filesWithBase64.length === selectedFiles.length) {
  //                 setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);

  //             }
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // }
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
        }
      };
      reader.readAsDataURL(file);
    });
  };
  const imageUpload = () => {
    setGridSelect(prevGridSelect =>
      prevGridSelect.map(item => {
        if (item.uid === selectedRowId) {
          return { ...item, files: files, base64Files: base64Files };
        }
        return item;
      })
    );
    setShowModalUpload(false);
  };
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // +++++++++++++++++++++++++++++++++++ Silk Slider
  // const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
  const findPrimary = selectedRowData?.attachments;
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };



  const isModalClose = () => {
    setIsModal(false);
  }

  const [actArcModal, setActArcModal] = useState(false);
  const handleMoveToActArc = () => {
    if (gridSelect.length <= 0) {
      toast.error('Please select grid data before send');
    } else {
      setActArcModal(true);
      // setModalAction(() => confirmMoveToActArc); // Set the action to be performed on confirmation
    }
  };
  const confirmMoveToActArc = async () => {
    // console.log('101', gridSelect);
    const sendAction = activeTab == 'Active' ? 'R' : 'A';
    const uldNumbers = gridSelect && gridSelect.map(num => num.awbId)
    try {
      const res = await withRFSToken.post('shipment-export/move-to-archive', { awbId: uldNumbers })
        .then(function (res) {
          if (res.data.response_code == 200) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
            // setGridSelect([]);
            window.$(gridRef.current).jqxGrid('updatebounddata');
            // fetchDataGrid()
            // if (activeTab == 'Active') {
            //     toast.success('ULD Data moved to Arhive');
            //     fetchDataGrid()
            // } else {
            //     toast.success('ULD Data moved to Active');
            //     fetchDataGridR()
            // }
            setActArcModal(false)
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const [modalData, setModalData] = useState({ awbId: '' });
  const [modalSec, setModalSec] = useState('');
  const modalInputChange = (name, value) => {
    setModalData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }

  const setLocation = async () => {
    if (modalData.location === '' || modalData.shipment_id === '') {
      toast.error((modalSec === 'L' ? 'Location' : 'Shipment Id') + ' field should not be blank')
    } else {
      let payload;
      if (modalSec === 'L') {
        payload = {
          awbId: modalData.awbId,
          location: modalData.location,

        }
      } else {
        payload = {
          awbId: modalData.awbId,
          shipment_id: modalData.location,
  
        }
      }
      // const payload = {
      //   awbId: modalData.awbId,
      //   location: modalData.location,

      // }
      // isModalClose();
      try {
        const res = await withRFSToken.post('shipment-export/set-action', modalData);
        if (res.data.response_code == 200) {
          toast.success(res.data.response_msg);
          setGridSelect([]);
          isModalClose();
          setTimeout(() => {
            setIsLoading(false);
            window.$(gridRef.current).jqxGrid('updatebounddata')
          }, 1);
          setGridSelect([])
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }

    }
  }

  const resetFilters = () => {
    window.$(gridRef.current).jqxGrid('clearfilters');
    // gridSelect.forEach(item => {
    //     const selectedRowBoundIndex = item.boundindex;
    //     window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
    // });
    // setGridSelect([]);
  };
  const createCargo = () => {
    localStorage.setItem('ccbackUrl', '/ForwarderShipments/Export');
    history.push('/ForwarderShipments/CreateCargo');
  };

  return (
    <>
      {console.log('modalData',modalData)}
      {console.log('modalSec',modalSec)}
      {galleryOpen && <GalleryView attachments={selectedRowData.attachments} attachment_sec='oa' onClose={closeGalleryModal} />}
      <div className="mb-3 nestedtabs rounded minh">
        <div className='d-flex'>
          {/* <button className="addtruck me-2" variant="primary" onClick={createCargo}>
            <span> <FontAwesomeIcon icon={faPlus} />  Create Cargo</span>
          </button> */}
          {/* <Dropdown>
            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
              <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'In Operation')}>Airway Bill</Dropdown.Item> */}
          {/* <Dropdown.Item onClick={() => handleDropdownItemClick('On Air')}>On Air</Dropdown.Item> */}
          {/* <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'Repair In')}>Archive</Dropdown.Item> */}
          {/* </Dropdown.Menu>
          </Dropdown> */}
          {/* <span className="selected">
            Selected Row <Badge>{gridSelect.length}</Badge>
          </span> */}
          {activeTab === 'Active' &&
            <div className='ulddown'>
              {/* <button onClick={handleMoveToActArc}> <img title='' src={Arcv} /> Archive </button> */}
            </div>
          }
        </div>
      </div>
      <div className="maindiv">
        <div className='trashdonload position-relative'>
          {!isLoading && 
          <>
          {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
           <div ref={gridRef} className='bookinggrid' ></div> 
          </>}
          {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
            <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              }
            </Tab>
            <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
              {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
              {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
            </Tab>
          </Tabs> */}
        </div>
        {selectedRowData && (
          <div className='SecondDiv'>
            {/* {console.log('55', selectedRowData)} */}
            <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
            <div className='girddtals_header'>
              <h3>
                {selectedRowData?.label_id} &nbsp; <span>{selectedRowData.status}</span>
              </h3>
              <div className='d-flex actbtn'>
                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
              </div>

            </div>
            <div className='mt-3'>
              <div className='mb-3'>
                <h3>Highlighted Image(s)</h3>
                {selectedRowData?.attachments && (
                  <>
                    <div className="g_parent">
                      {findPrimary.slice(0, 5).map((file, index) => {
                        let classN = '';
                        if (findPrimary.length === 1) {
                          classN = 'double'
                        } else if (findPrimary.length === 2) {
                          classN = 'double'
                        } else if (findPrimary.length === 3) {
                          classN = 'third'
                        } else if (findPrimary.length > 3) {
                          classN = 'more'
                        }
                        return (
                          <>
                            <div className={`${classN}${index + 1}`}>
                              <img
                                src={file.file_path}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",

                                }}

                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                onClick={() =>
                                  handleFileClick(file.file_path)
                                }
                              />
                            </div>
                          </>
                        )
                      })}
                      {findPrimary.length > 5 && (
                        <div className='more'>
                          <button className="more-btn" onClick={showGalleryModal}>
                            +{findPrimary.length - 5}
                          </button>
                        </div>
                      )}
                    </div>


                    {/* <div className='main_primary shipment_gl'>
                      {findPrimary.slice(0, 4).map((file, index) => {
                        const fileName = file?.file_name;
                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                        const extension = fileName?.split(".").pop();
                        return (
                          <>
                            <div key={`ns_${index}`} className='primary_image'>
                              {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                              ) ? (
                                <>
                                  {console.log('findPrimary', findPrimary.length)}

                                  <div className={index === 0 ? 'g_big' : ''}>
                                    <img
                                      src={file.file_path}
                                      alt="Preview"
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",

                                      }}

                                      // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                      onClick={() =>
                                        handleFileClick(file.file_path)
                                      }
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <span className="">
                                    <img src={Docmnt} className="fileimg" />
                                  </span>
                                </>
                              )}
                              <span className="rafilename">
                                {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                              </span>
                            </div>
                          </>
                        );
                      })}
                      {findPrimary.length > 4 && (
                        <div className='more'>
                          <button className="more-btn" onClick={showGalleryModal}>
                            +{findPrimary.length - 4}
                          </button>
                        </div>
                      )}
                    </div> */}
                  </>
                )}
              </div>
              <div>
                <h3>Shipment Information</h3>
                <ul className='truck_info'>
                  <li><span>Address LBL :</span> <span>{selectedRowData.address_lbl}</span></li>
                    <li><span>DG :</span> <span>{selectedRowData.dg}</span></li>
                    <li><span>DG LBL :</span> <span>{selectedRowData.dg_lbl}</span></li>
                    <li><span>Accepted By :</span> <span>{selectedRowData.accepted_by}</span></li>
                    <li><span>Security :</span> <span>{selectedRowData.security}</span></li>
                    <li><span>Remarks :</span> <span>{selectedRowData.remarks}</span></li>
                  
                </ul>
                </div>
            </div>

            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"acceptance"}
              attachable_id={selectedRowData.awbId}
              attachments={selectedRowData.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData.awbId)}
            />
            <ActivityComments
              commentable_type={"acceptance"}
              commentable_id={selectedRowData.awbId}
              allactivities={selectedRowData.activities}
              onReloadDetails={loadDetails}
            />
          </div>
        )}
      </div>
      <Modal show={isModal} onHide={!isSaving ? isModalClose : null} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Set Shipment {modalSec === 'L' ? 'Location' : 'Id'}</h3>
          <p>{modalData.shipmentId}</p>
          <div className='saairbill mb-2'>
            <Form.Label>Set Shipment {modalSec === 'L' ? 'Location' : 'Id'}<span>*</span></Form.Label>
            <Form.Control type="text"
              name={modalSec === 'L' ? 'location' : 'shipment_id'}
              value={modalSec === 'L' ? modalData.location : modalData.shipment_id || ''}
              maxLength={13}
              placeholder={modalSec === 'L' ? 'location' : 'Shipment Id'}
              // maxLength='5' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); }}
              onChange={(e) => modalSec === 'L' ? modalInputChange('location', e.target.value) : modalInputChange('shipment_id', e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="danger" disabled={isSaving} className='position-relative' onClick={isModalClose}>
                  Cancel
                </Button> */}
          <Button variant="primary" disabled={isSaving} className='position-relative' onClick={setLocation}>
            {isSaving ? <>Updating...<div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Update'}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={actArcModal} onHide={() => setActArcModal(false)} className='addfrom change_type' centered >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>Selected {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} will move to {activeTab == 'Active' ? 'Archive' : 'Active'}</h3>
          <p>Are you sure you want to move {gridSelect.length > 1 ? "Shipment's" : 'Shipment'} to {activeTab == 'Active' ? 'Archive' : 'Active'}?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => setActArcModal(false)}>
              No
            </Button>
            <Button variant="primary" onClick={confirmMoveToActArc}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose} centered className="imgmodal">
        <Modal.Header closeButton onClick={handleClose}></Modal.Header>
        <Modal.Body>
          {/* {console.log(selectedFile)} */}
          <img src={selectedFile} className="img-fluid" alt="Selected" />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Acceptance